import React from 'react'
import { J2Validate } from '@e3dc-react/icons'
import { IconButton } from '@mui/material'

const EMobilityChargingCardTableCheckIcon = (): React.ReactElement => {
  return (
    <IconButton>
      <J2Validate />
    </IconButton>
  )
}

export default EMobilityChargingCardTableCheckIcon
